import { render, staticRenderFns } from "./VerContatos.vue?vue&type=template&id=13ab6444&"
import script from "./VerContatos.vue?vue&type=script&lang=js&"
export * from "./VerContatos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports